require("clover/utils/GameSpeedManager")

let manualSpeed = false
let oldSetTimeScale = cc.Scheduler.prototype.setTimeScale
cc.Scheduler.prototype.setTimeScale = function (val, force) {
    if (manualSpeed && !force) return

    oldSetTimeScale.call(this, val)
}

$gameSpeed = function (val) {
    GameSpeedManager.getInstance().updateSpeedValue(val, manualSpeed)
    manualSpeed = true
}

$showMap = function (map, key, key2) {
    let result = ''
    for (let r = 1; r < map.length; r++) {
        for (let c = 1; c < map[r].length; c++) {
            result += key ? (key2 ? map[r][c][key][key2] : map[r][c][key]) : map[r][c]
            if (c < map[r].length - 1) {
                result += '\t'
            }
        }
        result += '\n'
    }
    return result
}

$watchSet = function (obj, key, when) {
    let val = obj[key]
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: true,
        get: () => val,
        set: function (v) {
            if (!when || when && when(v, val)) {
                debugger
            }
            val = v
        }
    })
}

$unWatch = function (obj, key) {
    let val = obj[key]
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: true,
        get: () => val,
        set: function (v) {
            val = v
        }
    })
}

$objdiff = function (x, y) {
    var b = false;
    for (var p in x) {
        if (y[p] === undefined && x[p] !== undefined) {
            cc.log("diff: 1:" + p + " " + x[p] + " - 2:empty")
            b = true
        }
        if (x[p] == "[object Object]") continue;
        if (x[p] != y[p]) {
            cc.log("diff: 1:" + p + " " + x[p] + " - 2:" + y[p])
            b = true

        }
    }
    for (var k in y) {
        if (x[k] === undefined && y[k] !== undefined) {
            cc.log("diff: 1: emtpy - 2:" + k + " " + y[k])
            b = true
        }
    }

    return b
}

$cacheLength = function() {
    let result = [
        cc.loader.cache,
        cc.spriteFrameCache._spriteFrames,
        cc.textureCache._textures
    ].map(item => Object.keys(item).length)
    console.log('loader, sf, text:', result)
}

cc.Node.prototype.$baseInfo = function () {
    return {
        running: this._running,
        visible: this._visible,
        parent: this._parent,
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        scaleX: this.scaleX,
        scaleY: this.scaleY,
    }
}

cc.Node.prototype.$countChildren = function () {
    let count = 0

    function _count(node) {
        if (node && node.children) {
            count += node.children.length
            node.children.forEach(item => _count(item))
        }
    }

    _count(this)
    return count
}

$moves = function (moves) {
    cc.director.getRunningScene().logic.theCurrentMoves = moves
}
$quickKillBoss = function () {
    GamePlayConfig_BOSS_DAMAGE_COLORFUL = 10000
}
$target = function (target) {
    if (typeof target === 'object') {
        for (var i = 0; i < target.length; i++) {
            cc.director.getRunningScene().logic.theOrderList[i + 1].targetNum = target[i]
        }
    } else {
        cc.director.getRunningScene().logic.theOrderList[1].targetNum = target
    }
}

$replay = function (replay) {
    require.ensure([], () => {
    // 很多地方依赖没写，跳过HomeScene导致引用缺失，此处就直接引
    require.ensure([], () => {
        require("clover/clover")
        require("clover/scene/HomeScene")
        require('clover/gamePlay/CreateGameSceneLogic')
    
        replay = $table(table.deserialize(replay)["1"])
        var id = replay.id
        var score = replay.score
        // var levelId = opLog.level
        var levelId = replay.level
        var levelType = LevelType.getLevelTypeByLevelId(levelId)
        // var selectedItemsData = opLog.selectedItemsData
        var selectedItemsData = replay.selectedItemsData
        var scene = cc.Director.getInstance().getRunningScene()
        require('clover/gamePlay/CreateGameSceneLogic')
        Nightmare.log('create game')
        var logic = CreateGameSceneLogic.create(levelId, table()) //selectedItemsData
        logic.startReplayGamePlayScene(replay, id, score)
    }, null, 'act')

    replay = $table(table.deserialize(replay)["1"])
    var id = replay.id
    var score = replay.score
    // var levelId = opLog.level
    var levelId = replay.level
    var levelType = LevelType.getLevelTypeByLevelId(levelId)
    // var selectedItemsData = opLog.selectedItemsData
    var selectedItemsData = replay.selectedItemsData
    var scene = cc.Director.getInstance().getRunningScene()
    require('clover/gamePlay/CreateGameSceneLogic')
    Nightmare.log('create game')
    var logic = CreateGameSceneLogic.create(levelId, table()) //selectedItemsData
    logic.startReplayGamePlayScene(replay, id, score)
    }, null, 'act')
    
}

let lastTextures = []

function diffArray (a, b) {
    return a.filter(i => !b.includes(i))
};

$diffTextures = function () {
    let cachedTextures = Object.keys(cc.textureCache._textures)
    let add = diffArray(cachedTextures, lastTextures)
    let sub = diffArray(lastTextures, cachedTextures)
    lastTextures = cachedTextures.slice()
    console.info('current count', cachedTextures.length)
    if (add.length || sub.length) {
        add.length && console.info('add', add)
        sub.length && console.info('sub', sub)
    } else {
        console.info('nothing changed')
    }
}
